<template>
    <div>
        <slot v-bind="{ gotoDirs, updateDates, updateRooms }"></slot>
    </div>
</template>
<script>
import EventBus from "../utils/eventBus";

export default {
    name: "dirs-form",

    data: () => ({
        arrival: "",
        departure: "",
        rooms: [],
        adults: 0,
        children: 0
    }),

    mounted() {
        EventBus.$on("dirs-form-update", payload => {
            console.log("dirs form update: ", payload);
        });
    },

    methods: {
        gotoDirs() {
            const baseUrl = `https://onepagebooking.com/am-suedwaeldchen`;
            const queryParamsOnePageBooking = new URLSearchParams({
                arrival: this.arrival,
                departure: this.departure,
                rooms: this.rooms,
                adults: this.adults,
                children: this.children
            }).toString();

            const url = `${baseUrl}?${queryParamsOnePageBooking}`;

            window.open(url, "_blank").focus();
        },

        updateDates(dates) {
            this.arrival = this.toDirsDateFormat(dates.start);
            this.departure = this.toDirsDateFormat(dates.end);
        },

        toDirsDateFormat(date) {
            // YYYY-MM-DD
            let parsed = new Date(Date.parse(date));
            let year = parsed.getFullYear();
            // force leading zero for month. getMonth ist zeroBased so we need to add +1
            let month = ("0" + (parsed.getMonth() + 1)).slice(-2);
            let day = ("0" + parsed.getDate()).slice(-2); // force leading zero for day
            return `${year}-${month}-${day}`;
        },

        updateRooms(rooms) {
            this.rooms = rooms.length;
            this.adults = rooms.reduce((acc, room) => acc + room.adults, 0);
            this.children = rooms.reduce((acc, room) => acc + room.children, 0);
        },

        roomToDirsCsv(room) {
            let adults = this.countToDirsArray(room.adults, "a");
            let children = this.countToDirsArray(room.children, "6");
            let combined = adults.concat(children);
            return combined.join(",");
        },

        countToDirsArray(count, representation) {
            let dirsArr = [];
            for (let index = 0; index < count; index++) {
                dirsArr.push(representation);
            }
            return dirsArr;
        }
    }
};
</script>
